<template>
    <div class="blog-posts">
        <Breadcrumb :breadcrumb="breadcrumb" class="mb-5"/>
        <b-container>
            <b-row>
                <b-col cols="12" lg="8" class="mb-4">
                    <b-col cols="12" class="blog-posts-title-block">
                        <div class="blog-posts-title">Acompanhe nosso blog!</div>
                    </b-col>
                    <div v-if="blog_posts.length <= 0">Não há postagens no momento!</div>
                    <template v-else>
                        <div v-for="post in blog_posts" :key="post.id" class="post mb-4">
                            <nuxt-link :to="post.route" class="row">
                                <b-col cols="12" lg="5" class="pl-lg-0">
                                    <div class="aspect-ratio ratio-4-3">
                                        <div class="aspect-content">
                                            <img class="object-fit-cover" v-lazy="imageUrl(post.image)" :alt="post.title">
                                        </div>
                                    </div>
                                </b-col>
                                <b-col cols="12" lg="7">
                                    <div class="post-datetime">
                                        {{ $dayjs(post.datetime).format('LL') }}
                                    </div>
                                    <div class="post-title">
                                        {{ post.title }}
                                    </div>
                                    <div class="post-shorttext">
                                        {{ truncate(post.short_text, 240, true) }}
                                    </div>
                                    <div class="post-link">Leia mais &gt;</div>
                                </b-col>
                            </nuxt-link>
                        </div>
                        <Pagination :total="blog_posts_total" :perPage="blog_posts_limit" @pagechanged="onPageChange"/>
                    </template>
                </b-col>
                <b-col cols="12" lg="4">
                    <BlogPostsProducts/>
                </b-col>
            </b-row>
        </b-container>
        <pre-footer-info/>
    </div>
</template>

<script>
    import BlogPostsProducts from "~/components/BlogPostsProducts";
    import utils from '~/mixins/utils';
    import Breadcrumb from "~/components/Breadcrumb";
    import Pagination from '~/components/Pagination.vue';
    import PreFooterInfo from '~/components/PreFooterInfo.vue';

    export default {
        mixins: [utils],
        components: {
            BlogPostsProducts,
            Breadcrumb,
            Pagination,
            PreFooterInfo
        },
        head() {
            return {
                title: this.title,
            }
        },
        data: function () {
            return {
                title: 'Blog'
            }
        },
        computed: {
            breadcrumb: function () {
                return [
                    {
                        name: 'Home',
                        link: '/'
                    },
                    {
                        name: 'Blog',
                        link: null
                    }
                ]
            }
        },
        methods: {
            onPageChange(page) {
                this.$router.push({path: this.$route.path, query: {page: page}})
            }
        },
        watchQuery: ['page', 'pagina'],
        async asyncData({params, query, res, $axios, req, app}) {
            try {
                const limit_posts = 15
                const blog_posts = await $axios.$get(`api/v1/blogs/posts?&blog_id=1&limit=10&page=${query.page}}&pagina=${query.page - 1}`);
                return {
                    blog_posts: blog_posts.data || [],
                    blog_posts_total: blog_posts.total_items,
                    blog_posts_limit: blog_posts.limit_items,
                }
            } catch (e) {
                console.error(e);
                return error({statusCode: 404, message: e.message})
            }
        }
    }
</script>
